module.exports = __webpack_public_path__ + "static/media/logo-krim-texel.4c091d47.png";